<template>
  <div class="bg-secondary-3">
    <div class="py-1 mb-3 px-4 rounded">
      <div class="row mt-4">
        <div class="col-12 d-flex">
          <i class="fas fa-clock text-orange mr-2 mt-1"></i>
          <p class="font-weight-normal font-18">
            Historial de Discusión de Informe de Progreso
          </p>
        </div>
      </div>
      <time-line class="col-12 mx-auto px-0 mb-3">
        <time-line-item
          v-for="(item, index) in history"
          :key="index"
          class="custom-time-line rounded"
        >
          <template #date>
            <div class="date-container text-right">
              <small>Fecha:</small>
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ formatDate(item.date) }}
                {{ getTimeFromDate(item.date) }}
              </div>
            </div>
          </template>
          <template #icon>
            <i
              class="color-white radius fa-1-2x"
              :class="getIcon(item.typeId)"
            ></i>
          </template>
          <div class="row bg-white rounded py-2">
            <div class="col-12 col-md-3 d-flex align-items-center">
              <label class="mb-0 px-2 text-gray-12 font-weight-bold">
                {{ item.type }}
              </label>
            </div>
            <div class="col-12 col-md-2 mt-2 flex-column d-flex">
              <label class="text-gray font-14">Estatus:</label>
              <p class="mb-0">
                <i
                  class="fas fa-circle font-12 mr-2"
                  :class="status(item.statusId).color"
                ></i>
                <span class="font-14">{{ status(item.statusId).text }}</span>
              </p>
            </div>
            <div class="col-12 col-md mt-2 flex-column d-flex">
              <label class="text-gray font-14">Usuario:</label>
              <span>{{ item.userName }}</span>
            </div>
            <div
              v-if="hasReason(item.reason)"
              class="col-12 col-md mt-2 flex-column d-flex"
            >
              <label class="text-gray font-14">Razón:</label>
              <span>{{ item.reason }}</span>
            </div>
          </div>
        </time-line-item>
      </time-line>
      <div v-if="hasMoreHistory" class="col-12">
        <div class="d-flex justify-content-center">
          <action-button
            type="button"
            i="fa fa-plus-circle pl-2"
            variant="success"
            class="pl-1 mr-2"
            @click="load"
          >
            Ver Más
          </action-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import moment from 'moment';
import ActionButton from 'ActionButton';
import { pieAcademicProgress } from '@/utils/constants/pei/progress-report-educational-services/pieAcademicProgress';
import { peiAcademicProgressLogTypefrom } from '@/utils/constants/pei/progress-report-educational-services/peiAcademicProgressLogType';

export default {
  name: 'AcademicProgressDiscussionHistory',
  components: {
    TimeLine,
    TimeLineItem,
    ActionButton,
  },
  props: {
    history: {
      type: Array,
      default: () => [],
    },
    hasMoreHistory: {
      type: Boolean,
      default: () => false,
    },
  },
  mounted() {
    this.$emit('load');
  },
  computed: {
    status() {
      return (id) => {
        switch (id) {
          case pieAcademicProgress.Unavailable:
            return {
              color: 'circle-unavailable',
              text: 'No Disponible',
            };
          case pieAcademicProgress.Pending:
            return {
              color: 'circle-pending',
              text: 'Pendiente',
            };
          case pieAcademicProgress.Submitted:
            return {
              color: 'circle-submitted',
              text: 'Sometido',
            };
          case pieAcademicProgress.Discussed:
            return {
              color: 'circle-discussed',
              text: 'Discutido',
            };
          default:
            return {
              color: 'circle-unavailable',
              text: 'No Disponible',
            };
        }
      };
    },
    hasReason() {
      return (value) => Boolean(value?.trim());
    },
  },
  methods: {
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    getTimeFromDate(value) {
      return moment(value).format('h:mm A');
    },
    getIcon(id) {
      switch (id) {
        case peiAcademicProgressLogTypefrom.ReplacementDocument:
          return 'fas fa-undo';
        case peiAcademicProgressLogTypefrom.ChangeStatus:
          return 'fas fa-arrows-retweet';
        case peiAcademicProgressLogTypefrom.ChangeDiscussionDate:
          return 'fas fa-calendar-alt';
        default:
          break;
      }
    },
    getStatusColor(id) {
      switch (id) {
        case pieAcademicProgress.Discussed:
          return 'circle-discussed';
        case pieAcademicProgress.Submitted:
          return 'circle-submitted';
        case pieAcademicProgress.Pending:
          return 'circle-pending';
        case pieAcademicProgress.Unavailable:
          return 'circle-unavailable';
        default:
          break;
      }
    },
    load() {
      this.$emit('load', 5);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.fa-1-2x {
  font-size: 1em;
}
.text-gray-12 {
  color: map-get($colors, 'gray-12');
}
.fas-img.fa-calendar-minus-circle-red {
  background-image: url('../../../../assets/img/calendar-minus-circle-red.svg');
}
.custom-time-line ::v-deep .icon-absolute {
  top: 33%;
}

label.text-gray {
  font-weight: normal !important;
}

.circle-unavailable {
  color: map-get($colors, 'gray-2');
}
.circle-pending {
  color: map-get($colors, 'primary-16');
}
.circle-submitted {
  color: #fae76f;
}
.circle-discussed {
  color: map-get($colors, 'green-light');
}
.custom-time-line {
  ::v-deep .w-date-fixed {
    width: 100px !important;
    margin-top: -12px !important;
  }
  ::v-deep .timeline__content {
    margin-bottom: unset !important;
  }
  ::v-deep .timeline__content--inner {
    padding-left: 20px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  ::v-deep .timeline__content:before {
    top: 50px !important;
    height: 100% !important;
  }
  ::v-deep .timeline__content:after {
    top: 50px !important;
  }
}

.custom-time-line:last-child ::v-deep .timeline__content:before {
  height: 0% !important;
}
</style>
